import axios from 'axios';
// import moment from "moment";
// import {downloadFile} from "@/helpers/helpers";
import {getField, updateField} from 'vuex-map-fields';

const getDefaultState = () => {
    return {
        addresses: {
            items: [],
            from: 0,
            to: 0,
            total: 0
        },
        address:{
            id_address:null,
            alias: '',
            company:'',
            firstname: '',
            lastname: '',
            address1: '',
            address2: '',
            postcode: '',
            city: '',
            country: '',
            state: '',
            phone: '',
            id_customer: 0,
        },
        states: [],
        countries: [],
        notification: {
            success:null,
            type:null,
            danger:null,
            message:null
        },
    }
}

export const state = getDefaultState();

export const getters = {
    getAddress: (state) => state.address,
    getAddresses: (state) => state.addresses,
    getField
}

export const actions = {
    async fetchAddress({commit}) {
        const response = await axios.get(`/fastmarket/account/address`);
        commit('SET_ADDRESSES', response.data);
    },
    async getAddress({commit}, data) {
        let response = await axios.post(`/customerservice/customers/address/get`, data);
        commit('SET_ADDRESS', response.data.data);
        response = await axios.post(`/customerservice/customers/address/getData`);
        commit('SET_STATES', response.data.states);
        commit('SET_COUNTRY', response.data.country);
    },
    cleanAddress({commit}) {
        commit('CLEAN_ADDRESS');
    },
    cleanAddressOffline({commit}, id_customer) {
        commit('CLEAN_ADDRESS_OFFLINE', id_customer);
    },
    /*eslint no-unused-vars: ["error", { "args": "none" }]*/
    async createAddress({commit, state} ) {
        const response = await axios.post(`/customerservice/customers/address/create`, state.address);
        return response.data;
    },
    async updateAddress({commit, state} ) {
        const response = await axios.post(`/customerservice/customers/address/update`, state.address);
        return response.data;
    },
    async deleteAddress({commit}, data) {
        const response = await axios.post(`/customerservice/customers/address/delete`, data);
        return response.data.success;
    },
}

export const mutations = {
    updateField,
    SET_ADDRESSES(state, result) {
        state.addresses = {
            items: result.data,
            from: result.meta.from,
            to: result.meta.to,
            total: result.meta.total
        }
    },
    SET_ADDRESS: (state, data) => {
        state.address = data
    },
    SET_STATES: (state, data) => {
        state.states = data
    },
    SET_COUNTRY: (state, data) => {
        state.countries = data
    },
    CLEAN_ADDRESS: (state) => {
        state.address = {
            id_address:null,
            alias: '',
            company:'',
            firstname: '',
            lastname: '',
            address1: '',
            address2: '',
            postcode: '',
            city: '',
            country: '',
            state: '',
            phone: '',
            id_customer: JSON.parse(localStorage.getItem('authUser')).id,
        }
    },
    CLEAN_ADDRESS_OFFLINE: (state, id_customer) => {
        state.address = {
            id_address:null,
            alias: '',
            company:'',
            firstname: '',
            lastname: '',
            address1: '',
            address2: '',
            postcode: '',
            city: '',
            country: '',
            state: '',
            phone: '',
            id_customer: id_customer,
        }
    },
}